import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M12.9311 9.2069C12.8488 9.2069 12.7699 9.1742 12.7117 9.116C12.6535 9.0578 12.6208 8.97886 12.6208 8.89655V5.7931C12.6208 5.21694 12.3919 4.66438 11.9845 4.25698C11.5771 3.84957 11.0245 3.62069 10.4484 3.62069C9.87222 3.62069 9.31966 3.84957 8.91225 4.25698C8.50484 4.66438 8.27596 5.21694 8.27596 5.7931V8.89655C8.27596 8.97886 8.24327 9.0578 8.18507 9.116C8.12686 9.1742 8.04793 9.2069 7.96562 9.2069C7.88331 9.2069 7.80437 9.1742 7.74617 9.116C7.68797 9.0578 7.65527 8.97886 7.65527 8.89655V5.7931C7.65527 5.05233 7.94955 4.34189 8.47335 3.81808C8.99716 3.29427 9.7076 3 10.4484 3C11.1892 3 11.8996 3.29427 12.4234 3.81808C12.9472 4.34189 13.2415 5.05233 13.2415 5.7931V8.89655C13.2415 8.97886 13.2088 9.0578 13.1506 9.116C13.0924 9.1742 13.0134 9.2069 12.9311 9.2069Z',
                    fill: '#DADCDE',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M13.5517 20.0689H3L3.62069 7.65515H12.931L13.5517 20.0689Z',
                    fill: '#EB423F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M16.0346 20.0689H13.5518L12.9312 7.65515H15.4139L16.0346 20.0689Z',
                    fill: '#D13330',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14.8116 18.5168C14.8054 18.5172 14.7992 18.5172 14.793 18.5172C14.7138 18.5172 14.6377 18.4869 14.5802 18.4326C14.5227 18.3783 14.488 18.3041 14.4834 18.2251L13.8627 7.67338C13.8623 7.66718 13.8623 7.66136 13.8623 7.65515H14.4838L15.1033 18.1886C15.1081 18.2708 15.0801 18.3516 15.0254 18.4131C14.9707 18.4747 14.8938 18.512 14.8116 18.5168Z',
                    fill: '#A82A27',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M20.9999 20.069H18.5172L18.4784 19.5674V19.567L17.8965 12H20.3792L20.9514 19.4363V19.4366L20.9999 20.069Z',
                    fill: '#EBA72E',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M19.7897 18.5157C19.7793 18.5168 19.7688 18.5173 19.7583 18.5173C19.6814 18.5172 19.6073 18.4885 19.5503 18.4369C19.4934 18.3853 19.4576 18.3144 19.4499 18.2379L19.4386 18.127L18.8292 12.031C18.8281 12.0207 18.8276 12.0104 18.8276 12H19.4499L20.0597 18.0987L20.0675 18.1759C20.0715 18.2164 20.0676 18.2574 20.0558 18.2964C20.0441 18.3354 20.0248 18.3718 19.999 18.4033C19.9732 18.4349 19.9414 18.461 19.9055 18.4803C19.8696 18.4996 19.8303 18.5116 19.7897 18.5157Z',
                    fill: '#E09F2C',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M21.0001 20.069H20.6269L19.7587 18.7663L18.8905 20.069H18.5173L18.4785 19.5674V19.567L19.4386 18.127L19.5003 18.0347C19.5287 17.9922 19.5671 17.9574 19.6122 17.9333C19.6573 17.9092 19.7076 17.8966 19.7587 17.8966C19.8098 17.8966 19.8601 17.9092 19.9052 17.9333C19.9502 17.9574 19.9887 17.9922 20.0171 18.0347L20.0597 18.0987L20.9516 19.4363V19.4367L21.0001 20.069Z',
                    fill: '#E09F2C',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M18.5172 20.069H10.4482L11.0689 12H17.8965L18.5172 20.069Z',
                    fill: '#F7B030',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M14.793 17.8966H14.1723C13.7609 17.8961 13.3665 17.7325 13.0756 17.4416C12.7847 17.1507 12.6211 16.7563 12.6206 16.3449V13.8621C12.6206 13.7798 12.6533 13.7009 12.7115 13.6427C12.7697 13.5845 12.8486 13.5518 12.931 13.5518C13.0133 13.5518 13.0922 13.5845 13.1504 13.6427C13.2086 13.7009 13.2413 13.7798 13.2413 13.8621V16.3449C13.2416 16.5917 13.3398 16.8284 13.5143 17.0029C13.6888 17.1774 13.9255 17.2756 14.1723 17.2759H14.793C15.0399 17.2756 15.2765 17.1774 15.4511 17.0029C15.6256 16.8284 15.7238 16.5917 15.7241 16.3449V13.8621C15.7241 13.7798 15.7568 13.7009 15.815 13.6427C15.8732 13.5845 15.9521 13.5518 16.0344 13.5518C16.1167 13.5518 16.1956 13.5845 16.2538 13.6427C16.312 13.7009 16.3447 13.7798 16.3447 13.8621V16.3449C16.3443 16.7563 16.1806 17.1507 15.8897 17.4416C15.5988 17.7325 15.2044 17.8961 14.793 17.8966Z',
                    fill: '#E9EEF2',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M5.79297 8.89661H6.41366V10.7587H5.79297V8.89661Z',
                    fill: '#DADCDE',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6.10331 9.2069C6.02101 9.2069 5.94207 9.1742 5.88387 9.116C5.82567 9.0578 5.79297 8.97886 5.79297 8.89655V5.7931C5.79297 5.05233 6.08724 4.34189 6.61105 3.81808C7.13486 3.29427 7.84529 3 8.58607 3C9.32685 3 10.0373 3.29427 10.5611 3.81808C11.0849 4.34189 11.3792 5.05233 11.3792 5.7931V8.89655C11.3792 8.97886 11.3465 9.0578 11.2883 9.116C11.2301 9.1742 11.1511 9.2069 11.0688 9.2069C10.9865 9.2069 10.9076 9.1742 10.8494 9.116C10.7912 9.0578 10.7585 8.97886 10.7585 8.89655V5.7931C10.7585 5.21694 10.5296 4.66438 10.1222 4.25698C9.71479 3.84957 9.16223 3.62069 8.58607 3.62069C8.00991 3.62069 7.45735 3.84957 7.04994 4.25698C6.64254 4.66438 6.41366 5.21694 6.41366 5.7931V8.89655C6.41366 8.97886 6.38096 9.0578 6.32276 9.116C6.26456 9.1742 6.18562 9.2069 6.10331 9.2069Z',
                    fill: '#E9EEF2',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M7.03443 13.2414H5.17236V10.7586L6.1034 10.1379L7.03443 10.7586V13.2414Z',
                    fill: '#F7B030',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const ShopColored = React.forwardRef(IconComponent);
ShopColored.displayName = 'ShopColored';

export { ShopColored };
